import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardHeader, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import BreadCrumb from '../../../../components/common/BreadCrumb';
import CustomDataAnalytics from './CustomDataAnalytics';
import InstallDeviceAnalytics from '../analytics/InstallDeviceAnalytics';
import SessionDataAnalytics from '../analytics/SessionDataAnalytics';
import TotalAppUserAnalytics from './TotalAppUserAnalytics';
import { useDispatch, useSelector } from 'react-redux';
import { getLicensesList } from '../../../../slices/veloxity/adminAnalytics/getLicensesList';
const AdminAnalytics = () => {
    document.title = "Admin Analytics";
    
    const dispatch = useDispatch();
    const [selectedLicenseKey, setSelectedLicenseKey] = useState(null);
    const [selectedAppName, setSelectedAppName] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const licenses = useSelector((state) => state.getLicensesList.licenses);
    const loading = useSelector((state) => state.getLicensesList.loading);

    useEffect(() => {
        dispatch(getLicensesList());
    }, [dispatch,selectedLicenseKey]);

    const filteredLicenses = licenses
        .filter(license => license.name.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => a.name.localeCompare(b.name));

    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

    const handleLicenseChange = (license) => {
        setSelectedLicenseKey(license.license);  
        setSelectedAppName(license.name + " (" + license.type + ")");
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Admin Analytics" pageTitle="Admin" />
                    <Row>
                        <Col xxl={12}>
                            <Card>
                                <CardHeader className="d-flex align-items-center">
                                    <Dropdown isOpen={isDropdownOpen} toggle={toggleDropdown} className="w-100">
                                        <DropdownToggle caret className="btn btn-light w-25 text-center py-2 px-3" style={{ fontSize: '1rem' }}>
                                            {loading ? "Loading..." : (
                                                selectedLicenseKey ? `${selectedAppName}` : "Select App"
                                            )}
                                        </DropdownToggle>
                                        <DropdownMenu className="w-100 p-2" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                            <Input
                                                type="text"
                                                placeholder="Search app..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                className="mb-2"
                                            />
                                            {filteredLicenses.slice(0, 5).map((license) => (
                                                <DropdownItem key={license.id} onClick={() => handleLicenseChange(license)}>
                                                    {`${license.name} (${license.type})`}
                                                </DropdownItem>
                                            ))}
                                        </DropdownMenu>
                                    </Dropdown>
                                </CardHeader>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xxl={12}>
                            <CustomDataAnalytics licenseKey={selectedLicenseKey} />
                        </Col>
                        <Col xxl={12}>
                            <InstallDeviceAnalytics licenseKey={selectedLicenseKey} />
                        </Col>
                        <Col xxl={12}>
                            <SessionDataAnalytics licenseKey={selectedLicenseKey} />
                        </Col>
                        <Col xxl={12}>
                            <TotalAppUserAnalytics licenseKey={selectedLicenseKey} />
                        </Col>

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default AdminAnalytics;
